import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationModalComponent } from '@app/shared/components';
import { Line } from '@app/shared/models/line.model';
import { ToolRequest } from '@app/shared/models/toolRequests.model';
import { Tool } from '@app/tool/model/tool.model';
import { ToolSet } from '@app/tool/model/toolSet.model';
import { LineService } from '@app/core/services/line.service';
import { ToolRequestsService } from '@app/core/services/tool-requests.service';
import { Log } from 'ng2-logger';

@Component({
  selector: 'app-search-line-and-request',
  templateUrl: './search-line-and-request.component.html',
  styleUrls: ['./search-line-and-request.component.scss']
})
export class SearchLineAndRequestComponent implements OnInit {
  _logger = Log.create(SearchLineAndRequestComponent.name);
  @ViewChild('successModal', {static: true}) confirmationModal: ConfirmationModalComponent;
  @ViewChild('errorModal', {static: true}) errorModal: ConfirmationModalComponent;

  currentStep = 1;
  firstNextTried = false;

  lines: any = [];
  selectedLine: Line;
  @Input() isLoading = false;

  toolRequests: ToolRequest[] = [];
  selectedToolRequest: ToolRequest;

  @Output() lineChanged = new EventEmitter<Line>();
  @Output() toolChanged = new EventEmitter<ToolRequest>();

  toolsNeededeAtLine: Array<Tool | ToolSet> = [];
  toolsNeededToBeReturned: Array<Tool | ToolSet> = [];

  confirmationPopupMessage: string;
  constructor(private lineService: LineService,
    private toolRequestService: ToolRequestsService) {
}

  ngOnInit() {
    this.getLines();
  }

  onLineChanged(line: Line) {
    this.selectedToolRequest = null;
        this.toolRequests = [];
        if (line && line instanceof Line) {
            this.selectedLine = line;
            this.toolsNeededeAtLine = [];
            this.toolsNeededToBeReturned = [];
            this.getToolRequestsForLine(line.id);
        }
     this.lineChanged.emit(line)
  }

  private getToolRequestsForLine(lineId: number) {
    this._logger.info("getTollRequestsForLine:: Retrieving Tool Request for lineId", lineId);
    this.toolRequestService.getAllToolRequestsForLine(lineId).subscribe(
        (data) => {
            this._logger.info("getTollRequestsForLine:: API Returned data", data);
            this.toolRequests = [...data.items];
        },
        (error) => {
            this.toolRequests = [];
            this._logger.info("getTollRequestsForLine:: API Returned error", error);
        }
    )
  }
  onToolRequestChanged(toolRequest: ToolRequest) {
     this.toolChanged.emit(toolRequest);
  }


  private getLines() {
    this._logger.info('getLines:: Retrieving list of lines');
    this.isLoading = true;
    this.lineService.getAllLines().subscribe(
        (data: any) => {
            this._logger.info('getLines:: API Returned data', data);
            this.lines = data.items;
            this.isLoading = false;
        },
        (error: any) => {
            this._logger.info('getLines:: API Returned error', error);
            this.isLoading = false;
        }
    );
  }
}
